<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formattedDate"
        label="Date of Birth"
        v-on="on"
        hint="M/D/YYYY"
        persistent-hint
        readonly
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="dateOnly"
      :max="maxDate"
      :min="minDate"
      @input="saveDate"
      no-title
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data: vm => ({
    date: "",
    formattedDate : vm.formatDate(vm.$props.value),
    dateOnly: vm.toDateOnly(vm.$props.value),
    menu: false,
    maxDate: new Date(Date.now() - 31536000000*3).toISOString().substring(0,10),
    minDate: new Date(Date.now() - 31536000000*100).toISOString().substring(0,10),
  }),
  watch: {
    menu: {
      deep: true,
      handler() {
        setTimeout(() => {
          this.$refs.picker.activePicker = "YEAR"
        })
      },
    },
    value (val) {
      this.formattedDate = this.formatDate(val)
      this.dateOnly = this.toDateOnly(val)
      this.date = val
    },
  },
  methods: {
    saveDate (date) {
      this.date = new Date(date).toISOString()
      this.$emit("input", this.date)
    },
    formatDate (date) {
      if (date) {
        const [year, month, day] = date.substring(0,10).split('-')
        return `${month}/${day}/${year}`
      }
      return null
    },
    toDateOnly (date) {
      if (date) {
        return date.substring(0,10)
      }
      return null
    }
  },
}
</script>
